import { useContext, useEffect, useRef, useState } from "react";
import {
  Form,
  Button,
  Steps,
  Card,
  notification,
  InputNumber,
  message,
  Tag,
  Tooltip,
  Input,
  Table,
  Modal,
  List,
  Space,
  ConfigProvider,
  Popconfirm,
} from "antd";
import { useTranslation } from "react-i18next";
import { useWatch } from "antd/es/form/Form";
import StepForm from "../ModalChooseTypeHomolaguation/StepForm";
import GlobalContext from "../../../context/GlobalContext";
import { BookOpen, Save, Trash2 } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addAffaire,
  saveAffaire,
  updateAffaireAnnexe,
} from "../../../api/geoprod";
import { useLoader } from "../../../context/LoaderContext";
import ModalValidPlanning from "./ModalValidPlanning";
import ConflictOrderModal from "./ConflictOrderModal";
import RapportInputs from "../../Rapporteur/RapportInputs";
import DeleteBrouillonModal from "../../Etablissements/CreateEpf/Modals/DeleteBrouillonModal";
import classes from "../../Etablissements/CreateEpf/CreateEpf.module.css";
import dayjs from "dayjs";

const { Step } = Steps;

const NouvelleHomologation = () => {
  const {
    form,
    globalData,
    setGlobalData,
    setShowConflictModal,
    conflictingPlages,
    currentConflictKey,
    showConflictModal,
    setOrderedConflicts,
    orderedConflicts,
    setNbrBrouillon,
  } = useContext(GlobalContext);
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [restantModules, setRestantModules] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const triggerNextStep = useRef(false);
  const autres_frais =
    useWatch("autres_frais", form) || globalData?.autres_frais;
  const modalite_selection =
    useWatch("modalite_selection", form) || globalData?.modalite_selection;
  const allFormValues = useWatch([], form);
  const nbrePeriode = useWatch("nbre_periode", form) || globalData?.nbrePeriode;

  const user = JSON.parse(localStorage.getItem("-x-token-user"));
  const params = useLocation();
  const ref = useRef();
  const role = localStorage.getItem("role");
  const { setIsLoading } = useLoader();
  const convention_partenarial_national =
    useWatch("convention_partenarial_national", form) ||
    globalData?.convention_partenarial_national;
  const raisons_mise_en_place_formation =
    useWatch("raisons_mise_en_place_formation", form) ||
    globalData?.raisons_mise_en_place_formation;
  const convention_partenarial_international =
    useWatch("Convention_partenariat_international", form) ||
    globalData?.convention_partenarial_international;
  const modalites_organisation_formation =
    useWatch("modalites_organisation_formation", form) ||
    globalData?.modalites_organisation_formation;

  const navigate = useNavigate();
  const rcapModulesColumns = [
    {
      title: "Module",
      dataIndex: "name",
      key: "name",
      render: (text) => text,
    },
    { title: "Intitulé du module", dataIndex: "intitulé", key: "intitulé" },
    {
      title: "Seuil de réussite",
      dataIndex: "seuil_réussite_value",
      key: "seuil_réussite_value",
    },
    {
      title: "Nombre d’heures programme référent",
      dataIndex: "nbre_heures_prgrm",
      key: "nbre_heures_prgrm",
    },
    {
      title: "Nombre d’heures proposé par le centre",
      dataIndex: "nbre_heures_proposé",
      key: "nbre_heures_proposé",
    },
    {
      title: "Heures théorique",
      dataIndex: "nbre_heures_théorique",
      key: "nbre_heures_théorique",
    },
    {
      title: "Heures pratique",
      dataIndex: "nbre_heures_pratique",
      key: "nbre_heures_pratique",
    },
    { title: "Type", dataIndex: "type", key: "type" },
  ];

  const disableFutureDates = (current) => {
    return current && current > dayjs().endOf("day");
  };

  const disableDateFin = (dateDebut) => {
    return (current) => {
      return current && current <= dayjs(dateDebut).endOf("day");
    };
  };

  const modules =
    globalData?.modules_formation ||
    form.getFieldValue("modules_formation") ||
    [];
  const moduleItems = modules[0]?.items || [];
  const ModulesListOptions = moduleItems.map((item) => ({
    label: item?.intitulé && item?.intitulé[0],
    value: item?.intitulé && item?.intitulé[0],
  }));
  const transformModulesTable = (
    data,
    duree_stage_heures_integration,
    duree_stage_heures_observation
  ) => {
    const numericFields = [
      "nbre_heures_prgrm",
      "nbre_heures_proposé",
      "nbre_heures_théorique",
      "nbre_heures_pratique",
    ];
    const normalizeType = (type) =>
      type?.toLowerCase() === "spécifique" ? "Spécifique" : "Général";
    const grouped = {
      Spécifique: [],
      Général: [],
    };
    data.forEach((item) => {
      const type = normalizeType(item?.type);
      grouped[type].push(item);
    });
    let moduleIndex = 1;
    const formatGroup = (typeLabel, items) => {
      if (!items.length) return { rows: [], totalRow: null };
      const rows = items.map((row) => ({
        ...row,
        type: typeLabel,
        name: `M${
          row?.type === "Général"
            ? import.meta.env.VITE_APP_TYPE_MODULE_GENERAL
            : import.meta.env.VITE_APP_TYPE_MODULE_SPECIFIQUE
        } ${moduleIndex++}`,
      }));
      const totalRow = {
        name: `Total ${typeLabel}`,
        type: typeLabel,
      };
      const validRows = items.filter(
        (row) => typeof row === "object" && row !== null
      );
      numericFields.forEach((field) => {
        totalRow[field] = validRows.reduce((sum, row) => {
          const value = parseFloat(row?.[field]);
          return sum + (isNaN(value) ? 0 : value);
        }, 0);
      });
      return { rows, totalRow };
    };
    const spécifiqueGroup = formatGroup("Spécifique", grouped.Spécifique);
    const généralGroup = formatGroup("Général", grouped.Général);
    const result = [];
    if (spécifiqueGroup.rows.length) {
      result.push(...spécifiqueGroup.rows, spécifiqueGroup.totalRow);
    }
    if (généralGroup.rows.length) {
      result.push(...généralGroup.rows, généralGroup.totalRow);
    }
    if (
      globalData?.modalites_organisation_formation !== "Formation en alternance"
    ) {
      result.push({
        name: "Stage d’intégration",
        type: "",
        nbre_heures_prgrm: 160,
        nbre_heures_proposé:
          duree_stage_heures_integration *
          parseInt(globalData?.duree_stage_mois_integration) *
          4,
      });
      result.push({
        name: "Stage d’observation",
        type: "",
        nbre_heures_prgrm: 160,
        nbre_heures_proposé:
          duree_stage_heures_observation *
          parseInt(globalData?.duree_stage_mois_observation) *
          4,
      });
    }

    if (spécifiqueGroup.totalRow || généralGroup.totalRow) {
      const finalTotal = {
        name: "Total enseignement général",
        type: "Total",
      };
      numericFields.forEach((field) => {
        finalTotal[field] =
          (spécifiqueGroup.totalRow?.[field] || 0) +
          (généralGroup.totalRow?.[field] || 0) +
          (field === "nbre_heures_prgrm"
            ? 160 * 2
            : field === "nbre_heures_proposé"
            ? (parseFloat(duree_stage_heures_integration) *
                parseInt(globalData?.duree_stage_mois_integration) *
                4 || 0) +
              (parseFloat(duree_stage_heures_observation) *
                parseInt(globalData?.duree_stage_mois_observation) *
                4 || 0)
            : 0);
      });
      result.push(finalTotal);
    }
    return result;
  };
  const transformedData = transformModulesTable(
    moduleItems,
    form.getFieldValue("duree_stage_heures_integration"),
    form.getFieldValue("duree_stage_heures_observation")
  );
  const space_data =
    params?.state?.epf_data?.data_form?.space_data ||
    globalData?.data_form?.space_data;
  const espacesOptions = space_data?.map((item) => ({
    label: item.space_data_label,
    value: item.space_data_label,
  }));
  const equipement_data =
    params?.state?.epf_data?.data_form?.equipments_data ||
    globalData?.data_form?.equipments_data;
  const equipenetsOptions = equipement_data?.map((item) => ({
    label: item.equipment_label,
    value: item.equipment_label,
  }));
  const handleChange = (weekIndex, moduleName, value) => {
    const moduleItem = modules[0]?.items.find((m) => m.intitulé === moduleName);
    if (!moduleItem) return;

    const currentValues = form.getFieldsValue();
    const totalMax = moduleItem?.nbre_heures_proposé || 0;

    let total = 0;

    for (let i = 0; i < globalData.duree_effective; i++) {
      const key = moduleName + (i + 1);
      const val = currentValues[key];
      if (typeof val === "number") {
        total += val;
      }
    }

    if (total > totalMax) {
      const restant = totalMax - (total - value);
      notification.error({
        message: t("Erreur"),

        description: t(
          `La valeur dépasse le nombre d'heures restantes autorisées pour ce module. Vous pouvez saisir au maximum ${restant}h.`
        ),
        duration: 0,
      });

      return;
    }
    const restantActuel = totalMax - total;

    const newData = [...data];
    newData[weekIndex - 1][moduleName] = value;

    setData(newData);
    const updatedRestantModules = {
      ...restantModules,
      [moduleItem.intitulé]: restantActuel,
    };
    setRestantModules(updatedRestantModules);
    setGlobalData({
      ...globalData,
      restantModules: updatedRestantModules,
      newData,
    });
    sessionStorage.setItem(
      "globalData",
      JSON.stringify({
        ...globalData,
        restantModules: updatedRestantModules,
      })
    );
  };

  const columns = [
    {
      title: t("Période"),
      dataIndex: "periode",
      render: (_, row) => {
        if (row.isYearRow) {
          return {
            children: null,
            props: { rowSpan: 0 },
          };
        }

        const index = row.realIndex;
        const type = form.getFieldValue("type_periode");

        const semainesParPeriodeList = [];
        let i = 1;
        while (true) {
          const value = parseInt(
            form.getFieldValue(`nbre_semaines_periode_${i}`)
          );
          if (isNaN(value)) break;
          semainesParPeriodeList.push(value);
          i++;
        }

        let cumulative = 0;
        let periodeIndex = -1;
        for (let j = 0; j < semainesParPeriodeList.length; j++) {
          cumulative += semainesParPeriodeList[j];
          if (index < cumulative) {
            periodeIndex = j;
            break;
          }
        }

        const periodeNom =
          type === "Semestrielle"
            ? `Semestre ${periodeIndex + 1}`
            : `Trimestre ${periodeIndex + 1}`;

        const debutPeriode = semainesParPeriodeList
          .slice(0, periodeIndex)
          .reduce((a, b) => a + b, 0);

        if (index === debutPeriode) {
          return {
            children: periodeNom,
            props: {
              rowSpan: semainesParPeriodeList[periodeIndex],
            },
          };
        }

        return {
          children: null,
          props: {
            rowSpan: 0,
          },
        };
      },
      fixed: "left",
      width: 120,
    },

    {
      title: "Semaine",
      dataIndex: "week",
      fixed: "left",
      render: (value, row) =>
        row?.isYearRow
          ? { children: null, props: { colSpan: 0 } }
          : "S" + value,
    },

    ...(Array.isArray(modules?.[0]?.items)
      ? modules[0].items.map((module, index) => {
          return {
            title: (
              <Tooltip title={module?.intitulé}>
                <span>
                  {`M${
                    module?.type === "Général"
                      ? import.meta.env.VITE_APP_TYPE_MODULE_GENERAL
                      : import.meta.env.VITE_APP_TYPE_MODULE_SPECIFIQUE
                  } ${index + 1}`}{" "}
                  {`(${restantModules[module?.intitulé]}h restantes)`}
                </span>
              </Tooltip>
            ),
            dataIndex: module?.intitulé,
            render: (value, row, idx) => {
              if (row?.isYearRow)
                return { children: null, props: { colSpan: 0 } };
              return (
                <Form.Item
                  name={`${module?.intitulé}${idx}`}
                  rules={[
                    { required: true, message: t("Veuillez remplir ce champ") },
                    {
                      validator: (_, value) => {
                        const moduleItem = modules[0]?.items.find(
                          (m) => m.intitulé === module?.intitulé
                        );
                        if (!moduleItem) return Promise.resolve();

                        const totalMax = moduleItem.nbre_heures_proposé || 0;
                        const currentValues = form.getFieldsValue();

                        let total = 0;

                        for (let i = 1; i < globalData.duree_effective; i++) {
                          const key = module?.intitulé + i;
                          const val = currentValues[key];
                          if (typeof val === "number") {
                            total += val;
                          }
                        }

                        if (total > totalMax) {
                          const restant = totalMax - (total - value);
                          return Promise.reject(
                            new Error(
                              `Valeur trop élevée. Maximum autorisé : ${restant}h.`
                            )
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    onChange={(val) => handleChange(idx, module?.intitulé, val)}
                    size="small"
                  />
                </Form.Item>
              );
            },
          };
        })
      : []),
    {
      title: "Charge hebdo",
      render: (_, row, index) => {
        if (row?.isYearRow) return { children: null, props: { colSpan: 0 } };
        let total = 0;
        for (const mod of modules[0]?.items) {
          const val = allFormValues?.[mod.intitulé + index];
          total += typeof val === "number" ? val : 0;
        }
        return `${total} h`;
      },
    },
  ];
  const getTransformedDataWithYears = () => {
    const nbrePeriode = parseInt(globalData?.nbre_periode, 10);
    const periodesParAn = globalData?.type_periode === "Semestrielle" ? 2 : 3;
    const semainesParPeriode = [];
    for (let i = 1; i <= nbrePeriode; i++) {
      const semaines = parseInt(
        globalData[`nbre_semaines_periode_${i}`] || 0,
        10
      );
      semainesParPeriode.push(semaines);
    }
    const newData = [];
    let currentWeekIndex = 0;
    for (
      let periodeIndex = 0;
      periodeIndex < semainesParPeriode.length;
      periodeIndex++
    ) {
      if (periodeIndex % periodesParAn === 0) {
        const yearNumber = Math.floor(periodeIndex / periodesParAn) + 1;
        newData.push({
          key: `year-${yearNumber}`,
          isYearRow: true,
          yearLabel: `${yearNumber}${yearNumber === 1 ? "ère" : "ème"} Année`,
        });
      }
      const semaines = semainesParPeriode[periodeIndex];
      for (let j = 0; j < semaines; j++) {
        const originalRow = data[currentWeekIndex];
        newData.push({
          ...originalRow,
          key: `week-${currentWeekIndex}`,
          realIndex: currentWeekIndex,
        });
        currentWeekIndex++;
      }
    }
    return newData;
  };
  const columnsWithAnnée = [
    ...columns,
    {
      title: "",
      key: "annee",
      render: (_, row) => {
        if (row?.isYearRow) {
          return {
            children: (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: 16,
                  textAlign: "center",
                }}
              >
                {row.yearLabel}
              </div>
            ),
            props: {
              colSpan: columns.length + 1,
            },
          };
        }
        return { children: null, props: { colSpan: 0 } };
      },
    },
  ];
  const recapColumns = [
    {
      title: "Semaine",
      dataIndex: "week",
      render: (_, __, index) => `S${index + 1}`,
    },
    ...(Array.isArray(modules?.[0]?.items)
      ? modules[0]?.items.map((mod, i) => ({
          title: (
            <Tooltip title={mod?.intitulé}>{`M${
              mod?.type === "Général"
                ? import.meta.env.VITE_APP_TYPE_MODULE_GENERAL
                : import.meta.env.VITE_APP_TYPE_MODULE_SPECIFIQUE
            }${i + 1}`}</Tooltip>
          ),
          dataIndex: mod?.intitulé,
          render: (val) => val || 0,
        }))
      : []),
    globalData?.modalites_organisation_formation !==
      "Formation en alternance" && {
      title: (
        <Tooltip title="Stage d'bservation">{`M${
          import.meta.env.VITE_APP_TYPE_MODULE_SPECIFIQUE
        }${modules[0]?.items?.length + 1}`}</Tooltip>
      ),
      dataIndex: "stageObservation",
      render: (val) => (val ? globalData?.duree_stage_heures_observation : ""),
    },
    globalData?.modalites_organisation_formation !==
      "Formation en alternance" && {
      title: (
        <Tooltip title="Stage d'intégration">{`M${
          import.meta.env.VITE_APP_TYPE_MODULE_SPECIFIQUE
        }${modules[0]?.items?.length + 2}`}</Tooltip>
      ),
      dataIndex: "stageIntegration",
      render: (val) => (val ? globalData?.duree_stage_heures_integration : ""),
    },
    {
      title: "Charge hebdo",
      dataIndex: "weeklyTotal",
      render: (val) => `${val || 0} h`,
    },
  ].filter(Boolean);
  const stageObs =
    globalData?.modalites_organisation_formation !== "Formation en alternance"
      ? globalData?.periode_stage_obseravation
      : null;
  const stageInt =
    globalData?.modalites_organisation_formation !== "Formation en alternance"
      ? globalData?.periode_stage_integration
      : null;
  const weeksObs = parseInt(globalData?.duree_stage_mois_observation * 4 || 0);
  const weeksInt = parseInt(globalData?.duree_stage_mois_integration * 4 || 0);
  const baseWeeks = globalData?.newData?.filter((row) => !row.isYearRow) || [];
  const recapData = [];
  const moduleEmptyRow = modules[0]?.items.reduce((acc, mod) => {
    acc[mod?.intitulé] = 0;
    return acc;
  }, {});
  let insertObsDone = false;
  let insertIntDone = false;
  baseWeeks.forEach((row, index) => {
    if (stageObs && !insertObsDone && index === stageObs.start + 1) {
      for (let i = 0; i < weeksObs; i++) {
        recapData.push({
          week: recapData.length + 1,
          ...moduleEmptyRow,
          stageObservation: globalData?.duree_stage_heures_observation || 0,
          stageIntegration: "",
          weeklyTotal: globalData?.duree_stage_heures_observation || 0,
          type: "special",
        });
      }
      insertObsDone = true;
    }
    if (stageInt && !insertIntDone && index === stageInt.start + 1) {
      for (let i = 0; i < weeksInt; i++) {
        recapData.push({
          week: recapData.length + 1,
          ...moduleEmptyRow,
          stageObservation: "",
          stageIntegration: globalData?.duree_stage_heures_integration || 0,
          weeklyTotal: globalData?.duree_stage_heures_integration || 0,
          isTotal: true,
        });
      }
      insertIntDone = true;
    }
    const weekObj = { week: recapData.length + 1 };
    let total = 0;
    modules[0]?.items.forEach((mod) => {
      const val = row[mod?.intitulé] || 0;
      weekObj[mod?.intitulé] = val;
      total += typeof val === "number" ? val : 0;
    });
    if (
      globalData?.modalites_organisation_formation !== "Formation en alternance"
    ) {
      weekObj.stageObservation = "";
      weekObj.stageIntegration = "";
    }

    weekObj.weeklyTotal = total;
    recapData.push(weekObj);
  });
  const insertSpecialLines = (weeksData, plagesMultiple, orderedConflicts) => {
    const result = [];
    const insertedKeys = new Set();
    const nbrePeriode = parseInt(globalData?.nbre_periode, 10);
    const periodesParAn = globalData?.type_periode === "Semestrielle" ? 2 : 3;
    const semainesParPeriode = [];
    for (let i = 1; i <= nbrePeriode; i++) {
      const semaines = parseInt(
        globalData[`nbre_semaines_periode_${i}`] || 0,
        10
      );
      semainesParPeriode.push(semaines);
    }
    let currentWeekIndex = 0;
    for (
      let periodeIndex = 0;
      periodeIndex < semainesParPeriode.length;
      periodeIndex++
    ) {
      if (periodeIndex % periodesParAn === 0) {
        const yearNumber = Math.floor(periodeIndex / periodesParAn) + 1;
        result.push({
          type: "year",
          key: `year-${yearNumber}`,
          yearLabel: `${yearNumber}${yearNumber === 1 ? "ère" : "ème"} Année`,
        });
      }
      const semaines = semainesParPeriode[periodeIndex];
      for (let j = 0; j < semaines; j++) {
        const row = {
          ...weeksData[currentWeekIndex],
          type: "normal",
          weekIndex: currentWeekIndex,
        };
        result.push(row);
        const specialEntries = [];
        for (const [type, plages] of Object.entries(plagesMultiple)) {
          for (const plage of plages) {
            let periode = null;
            if (type === "stage") {
              periode = Object.values(plage).find(
                (val) =>
                  val &&
                  typeof val === "object" &&
                  val.start === currentWeekIndex
              );
            } else if (type === "examen" || type === "rattrapage") {
              const key =
                type === "examen" ? "periode_examen" : "periode_rattrapage";
              if (plage[key]?.start === currentWeekIndex) {
                periode = plage[key];
              }
            } else if (type === "vacances") {
              if (plage.periode_vacances?.start === currentWeekIndex) {
                periode = plage.periode_vacances;
              }
            }
            if (periode) {
              let uniqueKey = `${periode.start}-${periode.end}-${type}`;
              if (type === "stage" && plage.stageType) {
                uniqueKey += `-${plage.stageType}`;
              }

              if (!insertedKeys.has(uniqueKey)) {
                insertedKeys.add(uniqueKey);
                specialEntries.push({
                  specialType: type,
                  label: {
                    examen: "Période d'évaluation",
                    rattrapage: "Période de rattrapage",
                    vacances: "Vacances",
                    stage: `Stage ${plage.stageType || ""}`,
                  }[type],
                  start: periode.start,
                  end: periode.end,
                  duration: periode.end - periode.start + 1,
                  plageData: plage,
                });
              }
            }
          }
        }
        const conflictKey = `${currentWeekIndex}-${currentWeekIndex + 1}`;
        let finalList = [];
        if (orderedConflicts && orderedConflicts[conflictKey]) {
          finalList = orderedConflicts[conflictKey].map(({ type, data }) =>
            specialEntries.find(
              (e) =>
                e.specialType === type &&
                e.start === data.start &&
                e.end === data.end &&
                (type === "stage"
                  ? e.plageData.stageType === data?.typeStage
                  : true)
            )
          );
        } else {
          const priority = { examen: 1, rattrapage: 2, vacances: 3, stage: 4 };
          finalList = specialEntries.sort((a, b) => {
            if (a.start !== b.start) return a.start - b.start;
            return (
              (priority[a.specialType] || 99) - (priority[b.specialType] || 99)
            );
          });
        }

        for (const entry of finalList) {
          if (!entry?.specialType || !entry?.label) {
            continue;
          }
          result.push({
            type: "special",
            specialType: entry?.specialType,
            label: entry?.label,
            startWeek: entry?.start,
            weekIndex: null,
            duration: entry?.duration,
            typeStage: entry?.plageData,
          });
        }
        currentWeekIndex++;
      }
    }
    return result;
  };
  const formValues = form.getFieldsValue();
  const plagesMultiple = {
    stage: [
      formValues.periode_stage_obseravation && {
        stage_observation: {
          start: formValues.periode_stage_obseravation.start,
          end: formValues.periode_stage_obseravation.end,
        },
        stageType: "observation",
      },
      formValues.periode_stage_integration && {
        stage_integration: {
          start: formValues.periode_stage_integration.start,
          end: formValues.periode_stage_integration.end,
        },
        stageType: "intégration",
      },
    ].filter(Boolean),
    examen: (formValues.semaines_examen?.[0]?.items || []).filter(
      (item) => item.examen_oui === "Oui"
    ),
    vacances: (formValues.semaines_vacances?.[0]?.items || []).filter(
      (v) => v && typeof v === "object"
    ),
    rattrapage: (formValues.semaines_examen?.[0]?.items || []).filter(
      (item) => item.ratrapage_oui === "Oui"
    ),
  };
  let transformedDataStages = insertSpecialLines(
    data,
    plagesMultiple,
    orderedConflicts
  );
  const recapModulesColumns = [
    {
      title: t("Période"),
      dataIndex: "periode",
      render: (_, row) => {
        if (row.type === "year") {
          return {
            children: null,
            props: { rowSpan: 0 },
          };
        }

        if (row.type === "special") {
          return { children: null, props: { rowSpan: 0 } };
        }

        const type = form.getFieldValue("type_periode");

        const semainesParPeriodeList = [];
        let i = 1;
        while (true) {
          const value = parseInt(
            form.getFieldValue(`nbre_semaines_periode_${i}`)
          );
          if (isNaN(value)) break;
          semainesParPeriodeList.push(value);
          i++;
        }

        const weekIndex = row.weekIndex;

        let cumulative = 0;
        let periodeIndex = -1;

        for (let j = 0; j < semainesParPeriodeList.length; j++) {
          cumulative += semainesParPeriodeList[j];
          if (weekIndex < cumulative) {
            periodeIndex = j;
            break;
          }
        }

        if (periodeIndex === -1)
          return { children: null, props: { rowSpan: 0 } };

        const periodeNom =
          type === "Semestrielle"
            ? `Semestre ${periodeIndex + 1}`
            : `Trimestre ${periodeIndex + 1}`;

        const debutPeriode = semainesParPeriodeList
          .slice(0, periodeIndex)
          .reduce((a, b) => a + b, 0);

        const finPeriode =
          debutPeriode + semainesParPeriodeList[periodeIndex] - 1;

        const lignesDansPeriode = transformedDataStages.filter((r) => {
          const idx =
            typeof r.weekIndex === "number" ? r.weekIndex : r.startWeek;
          return idx >= debutPeriode && idx <= finPeriode;
        });

        const isFirstRow = row.weekIndex === debutPeriode;

        if (isFirstRow) {
          return {
            children: periodeNom,
            props: {
              rowSpan: lignesDansPeriode.length,
            },
          };
        }

        return { children: null, props: { rowSpan: 0 } };
      },
      // width:120
    },
    {
      title: "Semaine",
      dataIndex: "week",
      render: (value, row) => {
        if (row.type === "year") {
          return {
            children: (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: 16,
                  textAlign: "center",
                }}
              >
                {row.yearLabel}
              </div>
            ),
            props: {
              colSpan: recapModulesColumns.length, // toute la largeur
            },
          };
        }

        if (row.type === "special") {
          const tagColors = {
            stage: "blue",
            examen: "red",
            rattrapage: "gold",
            vacances: "orange",
          };

          const tagColor = tagColors[row.specialType] || "default";

          return {
            children: <Tag color={tagColor}>{row.label}</Tag>,
            props: {},
          };
        }

        return "Semaine formation N°" + value;
      },
    },

    ...(modules?.[0]?.items || []).map((mod, index) => ({
      title: (
        <Tooltip title={mod?.intitulé}>{`M${
          mod?.type === "Général"
            ? import.meta.env.VITE_APP_TYPE_MODULE_GENERAL
            : import.meta.env.VITE_APP_TYPE_MODULE_SPECIFIQUE
        }${index + 1}`}</Tooltip>
      ),
      dataIndex: mod?.intitulé,
      render: (_, row) => {
        if (row.type === "year") {
          return {
            children: null,
            props: { colSpan: 0, style: { display: "none" } },
          };
        }
        if (row.type === "special") {
          return { children: null, props: { colSpan: 0 } };
        }
        const semaineIndex = row.weekIndex + 1;
        const value = globalData?.[`${mod.intitulé}${semaineIndex}`] || 0;
        return `${value} h`;
      },
    })),
    {
      title: "Charge hebdo",
      render: (_, row) => {
        if (row.type === "year") {
          return {
            children: null,
            props: { colSpan: 0, style: { display: "none" } },
          };
        }

        if (row.type === "special") {
          const iconMap = {
            stage: "🟦",
            examen: "🟥",
            rattrapage: "🟨",
            vacances: "🟧",
          };

          const labelMap = {
            stage: "Stage",
            examen: "Évaluation",
            rattrapage: "Rattrapage",
            vacances: "Vacances",
          };
          const specialType = row.specialType?.includes("periode_")
            ? row.specialType?.replace("periode_", "")
            : row.specialType;
          const icon = iconMap[specialType] || "⬜";
          const label = labelMap[specialType] || specialType;

          const plages = plagesMultiple?.[specialType] || [];
          const plage = plages.find((p) => {
            const periode = Object.values(p).find(
              (val) =>
                val && typeof val === "object" && val.start === row.startWeek
            );
            return !!periode;
          });

          let suffix = "";
          if (specialType === "stage") {
            const stageType = row.typeStage || plage?.stageType || "";
            const nbSemaines =
              stageType.stageType === "intégration"
                ? globalData?.duree_stage_mois_observation * 4
                : stageType.stageType === "observation"
                ? globalData?.duree_stage_mois_integration * 4
                : undefined;

            suffix = nbSemaines
              ? ` – ${stageType.stageType} – ${nbSemaines} ${
                  nbSemaines > 1 ? "semaines" : "semaine"
                }`
              : ` – ${stageType}`;
          } else {
            let nbreJours = 0;
            if (specialType === "vacances") {
              nbreJours = plage?.nbre_vacances_periode || 0;
            } else if (specialType === "rattrapage") {
              nbreJours = plage?.nbre_rattrapage_periode || 0;
            } else if (specialType === "examen") {
              nbreJours = plage?.nbre_examen_periode || 0;
            }

            suffix = nbreJours ? ` – ${nbreJours} jours` : "";
          }

          return {
            children: (
              <strong style={{ display: "block", textAlign: "center" }}>
                {`${icon} ${label}${suffix}`}
              </strong>
            ),
            props: {
              colSpan: recapModulesColumns.length,
            },
          };
        }
        let total = 0;

        // Additionner les heures stockées par semaine pour chaque module
        modules[0]?.items.forEach((mod) => {
          const semaineVal =
            globalData?.[`${mod.intitulé}${row.week}`] ||
            row[mod.intitulé] ||
            0;
          total += typeof semaineVal === "number" ? semaineVal : 0;
        });

        return `${total} h`;
      },
    },
  ];
  const buildModuleContentData = (module) => {
    const items = [];
    for (let i = 0; i < module?.nbre_elements_contenu; i++) {
      items.push({
        key: `${module?.intitulé}_element_${i}`,
        index: i,
        isTotal: false,
      });
    }
    items.push({
      key: `${module?.intitulé}_total`,
      isTotal: true,
    });
    return items;
  };
  const getModulePlanningColumns = (module) => [
    {
      title: "Élément de contenu",
      dataIndex: "element_contenu",
      render: (_, row) => {
        if (row.isHeader || row.isTotal) {
          return { children: null, props: { colSpan: 0 } };
        }
        return (
          <Form.Item
            name={`element_contenu_${module?.intitulé}_${row.index}`}
            rules={[
              { required: true, message: t("Veuillez remplir ce champ") },
            ]}
          >
            <Input.TextArea rows={1} />
          </Form.Item>
        );
      },
    },
    {
      title: "Contenu de formation",
      dataIndex: "contenu_formation",
      render: (_, row) => {
        if (row.isHeader) {
          return {
            children: (
              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                Intitulé du module : {module?.intitulé}
              </div>
            ),
            props: { colSpan: 4 },
          };
        }
        if (row.isTotal) {
          return {
            children: (
              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                TOTAL MODULE (H)
              </div>
            ),
            props: { colSpan: 2 },
          };
        }
        return (
          <Form.Item
            name={`contenu_formation_${module?.intitulé}_${row.index}`}
            rules={[
              { required: true, message: t("Veuillez remplir ce champ") },
            ]}
          >
            <Input.TextArea rows={1} />
          </Form.Item>
        );
      },
    },
    {
      title: "Durée/H Pratique",
      dataIndex: "duree_pratique",
      render: (_, row) => {
        if (row.isHeader) {
          return { children: null, props: { colSpan: 0 } };
        }
        if (row.isTotal) {
          return <strong>{module?.nbre_heures_pratique} h</strong>;
        }
        return (
          <Form.Item
            name={`duree_pratique_${module?.intitulé}_${row.index}`}
            rules={[
              {
                validator: (_, value) => {
                  const lastIndex = module?.nbre_elements_contenu - 1;

                  if (value === undefined || value === null || value <= 0) {
                    return Promise.reject(
                      new Error(t("Veuillez vérifier ce champ"))
                    );
                  }

                  let total = 0;
                  for (let i = 0; i < module?.nbre_elements_contenu; i++) {
                    const fieldName = `duree_pratique_${module?.intitulé}_${i}`;
                    const val = form.getFieldValue(fieldName);
                    total +=
                      i === row.index
                        ? typeof value === "number"
                          ? value
                          : 0
                        : typeof val === "number"
                        ? val
                        : 0;
                  }

                  if (total > module?.nbre_heures_pratique) {
                    return Promise.reject(
                      new Error(
                        t(
                          `Le total pratique ne doit pas dépasser ${module?.nbre_heures_pratique}h`
                        )
                      )
                    );
                  }

                  if (
                    row.index === lastIndex &&
                    total < module?.nbre_heures_pratique
                  ) {
                    return Promise.reject(
                      new Error(
                        t(
                          `Le total pratique doit être égal à ${module?.nbre_heures_pratique}h`
                        )
                      )
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        );
      },
      width: 150,
    },
    {
      title: "Durée/H Théorique",
      dataIndex: "duree_theorique",
      render: (_, row) => {
        if (row.isHeader) {
          return { children: null, props: { colSpan: 0 } };
        }
        if (row.isTotal) {
          return <strong>{module?.nbre_heures_théorique} h</strong>;
        }
        return (
          <Form.Item
            name={`duree_theorique_${module?.intitulé}_${row.index}`}
            rules={[
              {
                validator: (_, value) => {
                  const lastIndex = module?.nbre_elements_contenu - 1;

                  if (value === undefined || value === null || value <= 0) {
                    return Promise.reject(
                      new Error(t("Veuillez vérifier ce champ"))
                    );
                  }
                  let total = 0;
                  for (let i = 0; i < module?.nbre_elements_contenu; i++) {
                    const val = form.getFieldValue(
                      `duree_theorique_${module?.intitulé}_${i}`
                    );
                    total +=
                      i === row.index
                        ? typeof value === "number"
                          ? value
                          : 0
                        : typeof val === "number"
                        ? val
                        : 0;
                  }

                  if (total > module?.nbre_heures_théorique) {
                    return Promise.reject(
                      new Error(
                        t(
                          `Le total théorique ne doit pas dépasser ${module?.nbre_heures_théorique}h`
                        )
                      )
                    );
                  }

                  if (
                    row.index === lastIndex &&
                    total < module?.nbre_heures_théorique
                  ) {
                    return Promise.reject(
                      new Error(
                        t(
                          `Le total théorique doit être égal à ${module?.nbre_heures_théorique}h`
                        )
                      )
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        );
      },
      width: 150,
    },
  ];

  const generateModulesContentInputs = (modules) => {
    if (!Array.isArray(modules)) return [];

    return modules[0]?.items?.map((module) => ({
      name: `module_table_${module?.intitulé}`,
      type: "tableau",
      title: `${t("Module de formation")} : ${module?.intitulé}`,
      label: module?.intitulé,
      visible: true,
      columns: getModulePlanningColumns(module),
      moduleItems: buildModuleContentData(module),
      xs: 24,
      sm: 24,
      md: 24,
    }));
  };

  const steps = [
    {
      title: t("Établissement de formation"),
      visible: true,
      fields: {
        sections: [
          {
            name: t(
              "Cette section récapitule les informations concernant l'établissement de formation ayant formulé la demande d’homologation"
            ),
            visible: true,
            inputs: [
              // {
              //   name: "Information",
              //   label: t(
              //     "Cette section récapitule les informations concernant la structure de formation ayant formulé la demande d’homologation"
              //   ),
              //   type: "global",
              //   visible: true,
              //   xs: 24,
              //   sm: 24,
              //   md: 24,
              // },
              {
                name: "numEnregistrement",
                label: t("Numéro d'enregistrement"),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                readOnly: true,
              },
              {
                name: "denomination_epf",
                label: t("Dénomination de l’EPF"),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                readOnly: true,
              },
              {
                name: "adresse_epf",
                label: t("Adresse"),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                readOnly: true,
              },
            ],
          },

          {
            name: t(
              "Cette section porte sur les données relatives au diplôme pour lequel l’EPF souhaite obtenir l’homologation"
            ),
            visible: true,
            inputs: [
              // {
              //   name: "Information",
              //   label: t(
              //     "Cette section porte sur les données relatives au diplôme pour lequel l’EPF souhaite obtenir l’homologation"
              //   ),
              //   type: "global",
              //   visible: true,
              //   xs: 24,
              //   sm: 24,
              //   md: 24,
              // },
              {
                name: "Secteur",
                label: t("Secteur"),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                readOnly: true,
              },
              {
                name: "sousSecteur",
                label: t("Sous-secteur"),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                readOnly: true,
              },
              {
                name: "specialite",
                label: t("Spécialité"),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                readOnly: true,
              },
              {
                name: "diplome",
                label: t("Diplôme à homologuer"),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                readOnly: true,
              },
              {
                name: "raisons_mise_en_place_formation",
                label: t("Les raisons de la mise en place de la formation"),
                type: "checkbox",
                visible: true,
                xs: 24,
                sm: 16,
                md: 16,
                options: [
                  "Etude d’opportunité réalisée par la structure (à joindre au dossier si elle existe)",
                  "Besoins exprimés par les entreprises",

                  "Demandes exprimées par des jeunes",
                ],
              },
              {
                name: "document_etude_opportunite",
                label: t("Document d'étude d'opportunité"),
                type: "file",
                xs: 24,
                sm: 12,
                md: 24,
                visible: raisons_mise_en_place_formation?.includes(
                  "Etude d’opportunité réalisée par la structure (à joindre au dossier si elle existe)"
                ),
                buttonName: t(
                  "Joindre une copie du document de l'étude d'opportunité"
                ),
              },
              {
                name: "convention_partenarial_national",
                label: t("Convention de partenariat national"),
                type: "radio",
                visible: true,
                xs: 24,
                sm: 12,
                md: convention_partenarial_national === "Oui" ? 8 : 24,
                options: ["Oui", "Non"],
              },

              {
                name: "Convention_partenarial_national_citer",
                label: t("Titre de la convention natioanle"),
                type: "text",
                xs: 24,
                sm: 12,
                md: 8,
                visible: convention_partenarial_national === "Oui",
              },
              {
                name: "Convention_partenarial_national_upload",
                label: t("Document de la convention nationale"),
                type: "file",
                xs: 24,
                sm: 12,
                md: 8,
                visible: convention_partenarial_national === "Oui",
                buttonName: t("Joindre une copie de la convention nationale"),
              },
              {
                name: "Convention_partenariat_international",
                label: t("Convention de partenariat international"),
                type: "radio",
                visible: true,
                xs: 24,
                sm: 12,
                md: convention_partenarial_international === "Oui" ? 8 : 24,
                options: ["Oui", "Non"],
              },

              {
                name: "Convention_partenariat_l’international_citer",
                label: t("Titre de la convention internationale"),
                type: "text",
                xs: 24,
                sm: 12,
                md: 8,
                visible: convention_partenarial_international === "Oui",
              },
              {
                name: "Convention_partenarial_international_upload",
                label: t("Document de la convention internationale"),
                type: "file",
                xs: 24,
                sm: 12,
                md: 8,
                visible: convention_partenarial_international === "Oui",
                buttonName: t(
                  "Joindre une copie de la convention internationale"
                ),
              },

              // {
              //   name: "blank",
              //   label: "",
              //   type: "",
              //   visible: true,
              //   xs: 24,
              //   sm: 12,
              //   md: 8,
              //   required: false,
              // },
            ],
          },

          {
            name: t("Organisation administrative et pédagogique"),
            visible: true,
            inputs: [
              // {
              //   name: "Information",
              //   label: t(
              //     "Cette section récapitule les informations concernant la structure de formation ayant formulé la demande d’homologation"
              //   ),
              //   type: "global",
              //   visible: true,
              //   xs: 24,
              //   sm: 24,
              //   md: 24,
              // },
              {
                name: "organisation_administrative",
                label: t("Organisation administrative et pédagogique"),
                type: "checkbox",
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
                options: [
                  "Règlement intérieur",
                  "Cahier de classe",
                  "Dossier Apprenant",
                  "Emploi du temps",
                  "Dossiers formateurs",
                  "Tableau d’affichage",
                  "Service d’orientation",
                  "Service placement",
                  "Service d’ingénierie",
                ],
              },
              {
                name: "frais",
                label: t("Frais de formation"),
                type: "divider",
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
              },
              {
                name: "frais_formation",
                label: t("Frais de formation en Dinar par mois"),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                min: 0,
              },
              {
                name: "frais_evaluation",
                label: t("Frais de l’évaluation en Dinar par mois"),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                required: false,
                min: 0,
              },
              {
                name: "frais_hebergement",
                label: t("Frais de l’hébergement en Dinar par mois"),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                required: false,
                min: 0,
              },

              {
                name: "autres_frais",
                label: t("Autres frais"),
                type: "radio",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                options: ["Oui", "Non"],
                required: false,
              },
              {
                name: "preciser_autres_frais",
                label: t("Décrire les autres frais de formation"),
                type: "text",
                visible: autres_frais === "Oui",
                xs: 24,
                sm: 12,
                md: 8,
              },

              {
                name: "preciser_montant_frais",
                label: t("Montant des autres frais de formation"),
                type: "integer",
                visible: autres_frais === "Oui",
                xs: 24,
                sm: 12,
                md: 8,
                min: 0,
              },
              {
                name: "capacite",
                label: t("Capacité"),
                type: "divider",
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
              },
              {
                name: "capacite_acceuil_annuelle",
                label: t(
                  "Capacité d'accueil annuelle pour la spécialité concernée"
                ),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                min: 1,
              },
              {
                name: "nombre_apprenants_groupe",
                label: t(
                  "Nombre d’apprenants par groupe pour la spécialité concernée"
                ),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                min: 1,
                max: 20,
              },
              {
                name: "nombre_apprenants_groupe_info",
                label: t(
                  "Le nombre saisi ici sera utilisé comme maximum pour chaque groupe lors de la création d’une nouvelle session de formation"
                ),
                type: "infoLabel",
                visible: true,
              },
              {
                name: "nombre_groupes",
                label: t("nombre de groupes pour l'année de formation"),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                readOnly: true,
                min: 1,
              },
              {
                name: "organisation",
                label: t("Organisation de la formation"),
                type: "divider",
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
              },
              {
                name: "organisation_formation",
                label: t("Organisation de la formation"),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 12,
                readOnly: true,
              },
              {
                name: "modalites_organisation_formation",
                label: t("Modalités d'organisation de la formation"),
                type: "radio",
                visible: true,
                xs: 24,
                sm: 24,
                md: 12,
                options: [
                  "Formation en résidentiel",
                  "Formation en alternance",
                  "À distance",
                  "Apprentissage",
                ],
              },
              {
                name: "modalites_mise_oeuvre",
                label: t("Modalités de mise en œuvre"),
                type: "text",
                visible:
                  modalites_organisation_formation ===
                  "Formation en alternance",
                xs: 24,
                sm: 12,
                md: 7,
              },
              {
                name: "duree_periode_alternance",
                label: t("Durée des périodes d’alternance"),
                type: "integer",
                visible:
                  modalites_organisation_formation ===
                  "Formation en alternance",
                xs: 24,
                sm: 12,
                md: 7,
              },
              {
                name: "modalites_encadrement_entreprises",
                label: t(
                  "Modalités d’encadrement et de coordination avec les entreprises de production"
                ),
                type: "text",
                visible:
                  modalites_organisation_formation ===
                  "Formation en alternance",
                xs: 24,
                sm: 12,
                md: 10,
              },

              {
                name: "duree",
                label: t("Durées"),
                type: "divider",
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
              },

              {
                name: "duree_vacances",
                label: t("Durée des vacances en semaines"),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                min: 1,
                parserVirgule: true,
              },
              {
                name: "duree_evaluation",
                label: t("Durée des périodes d’évaluation en semaines"),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                min: 1,
                md: 8,
                parserVirgule: true,
              },
              {
                name: "duree_rattrapage",
                label: t("Durée des périodes de rattrapage en semaines"),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 8,
                min: 1,
                parserVirgule: true,
              },
              {
                name: "duree_effective",
                label: t(
                  "Durée de la formation effective en semaines (sans compter les vacances, les stages en entreprise, les examens et les évaluations.)"
                ),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 12,
                min: 1,
                parserVirgule: true,
              },
              {
                name: "duree_effective_totale",
                label: t(
                  "Durée de la formation effective en semaines (en comptant les vacances, les stages en entreprise, les examens et les évaluations.)"
                ),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 12,
                min: 1,
                parserVirgule: true,
                readOnly: true,
              },
              {
                name: "duree_effective_totale_info",
                label: t(
                  "La durée de la formation effective en semaines est la somme des semaines de vacances,évaluation,rattrapage et la durée de la formation effective"
                ),
                type: "infoLabel",
                visible: true,
              },

              {
                name: "type_periode",
                label: t("Type de période"),
                type: "radio",
                options: ["Semestrielle", "Trimestrielle"],
                visible: true,
                xs: 24,
                sm: 12,
                md: 12,
              },
              {
                name: "nbre_periode",
                label: t("Nombre de périodes"),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 12,
                min: 1,
              },
              // ...(nbrePeriode && Number(nbrePeriode) > 0
              //   ? Array.from({ length: Number(nbrePeriode) }).map((_, i) => ({
              //       name: `nbre_semaines_periode_${i + 1}`,
              //       label: t(`Nombre de semaines de la période ${i + 1}`),
              //       type: "integer",
              //       visible: true,
              //       xs: 24,
              //       sm: 12,
              //       md: 8,
              //       min: 1,
              //     }))
              //   : []),

              ...(nbrePeriode && Number(nbrePeriode) > 0
                ? Array.from({ length: Number(nbrePeriode) }).flatMap(
                    (_, i) => [
                      {
                        name: `nbre_semaines_periode_${i + 1}`,
                        label: t(`Nombre de semaines de la période ${i + 1}`),
                        type: "integer",
                        visible: true,
                        xs: 24,
                        sm: 12,
                        md: 8,
                        min: 1,
                      },
                      {
                        name: `nbre_semaines_periode_${i + 1}_info`,
                        label: t(
                          `La somme des ${nbrePeriode} périodes doit être égale à la durée effective de la formation (${
                            form.getFieldsValue()["duree_effective"]
                          } semaines).`
                        ),
                        type: "infoLabel",
                        visible: true,
                      },
                    ]
                  )
                : []),
            ],
          },
          {
            name: t(
              "Cette section récapitule les modalités de sélection et d’évaluation"
            ),
            visible: true,
            inputs: [
              // {
              //   name: "selection",
              //   label: t("Modalité de sélection"),
              //   type: "divider",
              //   visible: true,
              //   xs: 24,
              //   sm: 24,
              //   md: 24,
              // },
              {
                name: "niveau",
                label: t("Niveau minimum requis"),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 12,
                readOnly: true,
              },
              {
                name: "experience_professionnelle",
                label: t(
                  "Nombre d'expérience professionnelle (à décrire si exigé par votre EPF, sinon laisser vide)"
                ),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 12,
                required: false,
                min: 1,
              },
              {
                name: "autres_prerequis",
                label: t(
                  "Autres prérequis (à préciser si exigé par votre EPF, sinon laisser vide)"
                ),
                type: "text",
                visible: true,
                xs: 24,
                sm: 12,
                md: 12,
                required: false,
              },
              {
                name: "modalite_selection",
                label: t(
                  "Modalité de sélection (selectionnez une ou plusieurs réponses)"
                ),
                type: "checkbox",
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
                options: [
                  "Entretien individuel/collectif",
                  "Épreuves écrites",
                  "Évaluation des acquis",
                  "Tests psychotechniques",
                  "Concours",
                  "Autres",
                ],
              },
              {
                name: "autre_modalite_selection",
                label: t("Préciser"),
                type: "text",
                xs: 24,
                sm: 12,
                md: 12,
                visible: modalite_selection?.includes("Autres"),
              },
              // {
              //   name: "évaluation",
              //   label: t("Modes d'évaluation"),
              //   type: "checkbox",
              //   visible: true,
              //   xs: 24,
              //   sm: 12,
              //   md: 12,

              //   options: [
              //     t("Contrôle continu"),
              //     t("Evaluation Finale"),
              //     t("Session de rattrapage"),
              //     t("Condition d’obtention du diplôme"),
              //     t("Composition jury d’évaluation"),
              //   ],
              // },

              {
                name: "evaluation",
                label: t("L'évaluation"),
                type: "divider",
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
              },
              {
                name: "controle_continu",
                label: t("Contrôle continu"),
                type: "area",
                xs: 24,
                sm: 24,
                md: 24,
                visible: true,
                rows: 3,
              },
              {
                name: "evaluation_finale",
                label: t("Evaluation Finale"),
                type: "area",
                xs: 24,
                sm: 24,
                md: 24,
                visible: true,
                rows: 3,
              },
              {
                name: "session_rattrapage",
                label: t("Session de rattrapage"),
                type: "area",
                xs: 24,
                sm: 24,
                md: 24,
                visible: true,
                rows: 3,
              },
              {
                name: "condition_obtention_diplome",
                label: t("Condition d’obtention du diplôme"),
                type: "area",
                xs: 24,
                sm: 24,
                md: 24,
                visible: true,
                rows: 3,
              },
              {
                name: "composition_jury_evaluation",
                label: t("Composition jury d’évaluation"),
                type: "area",
                sm: 24,
                md: 24,
                visible: true,
                rows: 3,
              },
            ],
          },

          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "correspondance_definition_emploi",
          //       label: t(
          //         "Correspondance avec la définition de l’emploi dans la branche professionnelle concernée"
          //       ),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },
    {
      title: t("Modules de formation"),
      visible: true,
      fields: {
        sections: [
          {
            name: "test",
            visible: true,

            inputs: [
              {
                type: "accordion",
                name: "modules_formation",
                label: t("Modules de formation"),
                canAddItems: true,
                sections: [
                  {
                    label: t("Ajouter les modules de la formation"),
                    columns: [
                      {
                        name: "intitulé",
                        label: t("Intitulé du module"),
                        type: "selectTag",
                        options: [
                          { value: "Arabe", label: "Arabe" },
                          { value: "Français", label: "Français" },
                          { value: "Anglais", label: "Anglais" },
                          {
                            value: "Culture d'hygiène et sécurité au travail",
                            label: "Culture d'hygiène et sécurité au travail",
                          },
                          {
                            value: "Législation de travail",
                            label: "Législation de travail",
                          },
                          {
                            value:
                              "Education environnementale et maitrise de l'énergie",
                            label:
                              "Education environnementale et maitrise de l'énergie",
                          },
                          {
                            value: "Culture numérique",
                            label: "Culture numérique",
                          },
                          {
                            value:
                              "Culture de l'entreprise et du travail indépendant",
                            label:
                              "Culture de l'entreprise et du travail indépendant",
                          },
                        ],
                        md: 8,
                      },
                      // {
                      //   name: "seuil_réussite",
                      //   label: t("Type de seuil de réussite"),
                      //   type: "radio",
                      //   options: ["pourcentage", "sur 20"],
                      //   md: 8,
                      // },
                      {
                        name: "seuil_réussite_value",
                        label: t("Seuil de réussite"),
                        type: "integer",
                        md: 8,
                      },
                      {
                        name: "nbre_heures_prgrm",
                        label: t("Nombre d’heures du programme référent"),
                        type: "integer",
                        md: 8,
                        min: 1,
                      },
                      {
                        name: "nbre_heures_proposé",
                        label: t("Nombre d’heures proposé par le centre"),
                        type: "integer",
                        md: 8,
                        min: 1,
                      },
                      {
                        name: "nbre_heures_théorique",
                        label: t("Heures théoriques"),
                        type: "integer",
                        md: 8,
                        min: 1,
                      },
                      {
                        name: "nbre_heures_pratique",
                        label: t("Heures pratiques"),
                        type: "integer",
                        readOnly: true,
                        md: 8,
                        min: 1,
                      },
                      {
                        name: "nbre_elements_contenu",
                        label: t("Nombre d'éléments de contenu"),
                        type: "integer",
                        md: 8,
                        min: 1,
                      },
                      {
                        name: "type",
                        label: t("Type"),
                        type: "checkbox",
                        options: ["Général", "Spécifique"],
                        md: 8,
                      },
                      {
                        name: "objectifs",
                        label: t("Objectifs du module"),
                        type: "area",
                        md: 24,
                      },
                    ],
                  },
                ],
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
                buttonName: t("Ajouter un module de formation"),
                cardTitle: t("Module de formation"),
                cardType: "accordion",
                cardMd: 24,
                cardFieldsMd: 12,
              },
              {
                type: "card",
                name: "Stages",
                label: t("Stages"),
                visible:
                  globalData?.modalites_organisation_formation !==
                  "Formation en alternance",
                inputs: [
                  {
                    section: "Stage d'observation",
                    fields: [
                      {
                        name: "type_stage_observation",
                        label: t("Type"),
                        type: "text",
                        xs: 8,
                        readOnly: true,
                      },

                      {
                        name: "duree_stage_heures_observation",
                        label: t("Charge hebdomadaire"),
                        type: "integer",
                        xs: 8,
                        max: 40,
                        min: 40,
                      },
                      {
                        name: "duree_stage_mois_observation",
                        label: t("Durée(mois)"),
                        type: "radio",
                        options: [1, 2],
                        xs: 8,
                        min: 1,
                        max: 2,
                      },
                      // {
                      //   name: "nbre_semaines_stage_observation",
                      //   label: t("Nombre de semaines"),
                      //   type: "integer",
                      //   xs: 8,
                      //   min: 4,
                      //   max: 8,
                      // },
                    ],
                  },
                  {
                    section: "Stage d'intégration",
                    fields: [
                      {
                        name: "type_stage_integration",
                        label: t("Type"),
                        type: "text",
                        xs: 8,
                        readOnly: true,
                      },

                      {
                        name: "duree_stage_heures_integration",
                        label: t("Charge hebdomadaire"),
                        type: "integer",
                        xs: 8,
                        max: 40,
                        min: 40,
                      },
                      {
                        name: "duree_stage_mois_integration",
                        label: t("Durée(mois)"),
                        type: "radio",
                        options: [1, 2],
                        xs: 8,
                      },
                      // {
                      //   name: "nbre_semaines_stage_integration",
                      //   label: t("Nombre de semaines"),
                      //   type: "integer",
                      //   xs: 8,
                      //   min: 4,
                      //   max: 8,
                      // },
                    ],
                  },
                ],
                xs: 24,
                sm: 24,
                md: 24,
              },
            ],
          },
          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "correspondance_modules",
          //       label: t(
          //         "Contenu du programme par rapport à la qualification visée"
          //       ),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },

    {
      title: t("Éléments de contenu"),
      visible: true,
      fields: {
        sections: [
          {
            name: "elements_contenu",
            visible: true,
            inputs: generateModulesContentInputs(modules),
          },
          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "correspondance_modules",
          //       label: t(
          //         "Contenu du programme par rapport à la qualification visée"
          //       ),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },

    {
      title: t("Planification des modules"),
      visible: true,
      fields: {
        sections: [
          {
            name: "planning",
            visible: true,
            inputs: [
              {
                name: "modules_planning",
                label: t(""),
                type: "tableau",
                visible: true,
                columns: columnsWithAnnée,
                moduleItems: getTransformedDataWithYears(),
                xs: 24,
                sm: 12,
                md: 12,
                bordered: true,
              },
            ],
          },
          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "correspondance_modules",
          //       label: t(
          //         "Contenu du programme par rapport à la qualification visée"
          //       ),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },
    {
      title: t("Stages planning"),
      visible: true,
      fields: {
        sections: [
          {
            name: "planning",
            visible: true,
            inputs: [
              {
                name: "stages_planning",
                label: t(""),
                type: "tableau",
                visible: true,
                columns: recapModulesColumns,
                moduleItems: transformedDataStages,
                xs: 24,
                sm: 12,
                md: 12,
                bordered: true,
              },
              {
                name: "plages_stages",
                label: t("Stages"),
                type: "divider",
                visible:
                  globalData?.modalites_organisation_formation !==
                  "Formation en alternance",
                xs: 24,
                sm: 24,
                md: 24,
              },

              {
                name: "periode_stage_obseravation",
                label: t("Préciser la période du stage d'observation"),
                type: "range-week",
                xs: 24,
                sm: 12,
                md: 12,
                visible:
                  globalData?.modalites_organisation_formation !==
                  "Formation en alternance",
              },
              {
                name: "periode_stage_integration",
                label: t("Préciser la période du stage d'intégration"),
                type: "range-week",
                xs: 24,
                sm: 12,
                md: 12,
                visible:
                  globalData?.modalites_organisation_formation !==
                  "Formation en alternance",
              },
              {
                name: "plages_exams",
                label: t("Examens"),
                type: "divider",
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
              },
              {
                type: "accordion",
                name: "semaines_examen",
                label: t("Semaines d'évaluations"),
                defaultCount: parseInt(globalData?.nbre_periode),

                sections: [
                  {
                    label: t("Ajouter les semaines d'évaluations"),
                    columns: [
                      {
                        name: "examen_oui",
                        label: t(
                          `Avez-vous une période d'évaluation pour cette ${
                            globalData?.type_periode === "Semestrielle"
                              ? "semestre"
                              : "trimestre"
                          } ?`
                        ),
                        type: "radio",
                        options: ["Oui", "Non"],
                        xs: 24,
                        sm: 12,
                        md: 8,
                        visible: true,
                      },
                      {
                        name: "periode_examen",
                        label: t("Semaines d'évaluations"),
                        type: "range-week",
                        xs: 24,
                        sm: 12,
                        md: 9,
                        visible: false,
                      },

                      {
                        name: "nbre_examen_periode",
                        label: t("Nombre de jours"),
                        type: "integer",
                        xs: 24,
                        sm: 12,
                        md: 7,
                        visible: false,
                        min: 1,
                      },
                      {
                        name: "ratrapage_oui",
                        label: t(
                          "Avez-vous une période de ratrappage pour cette période d'évaluation ?"
                        ),
                        type: "radio",
                        options: ["Oui", "Non"],
                        xs: 24,
                        sm: 12,
                        md: 8,
                        visible: false,
                      },
                      {
                        name: "periode_rattrapage",
                        label: t("Semaines de rattrapage"),
                        type: "range-week",
                        xs: 24,
                        sm: 12,
                        md: 9,
                        visible: false,
                      },

                      {
                        name: "nbre_rattrapage_periode",
                        label: t("Nombre de jours"),
                        type: "integer",
                        xs: 24,
                        sm: 12,
                        md: 7,
                        visible: false,
                        min: 1,
                      },
                    ],
                  },
                ],
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
                buttonName: t("Ajouter une période d'évaluation"),
                cardTitle: t("Période d'évaluation"),
                cardType: "accordion",
                cardMd: 24,
                cardFieldsMd: 12,
              },
              // {
              //   name: "plages_rattrapage",
              //   label: t("Rattrapage"),
              //   type: "divider",
              //   visible: true,
              //   xs: 24,
              //   sm: 24,
              //   md: 24,
              // },
              // {
              //   type: "accordion",
              //   name: "semaines_rattrapage",
              //   label: t("Semaines de rattrapage"),
              //   defaultCount: parseInt(form.getFieldsValue()?.semaines_examen?.[0]?.items.filter((e)=>e.ratrapage_oui==="Oui")?.length),
              //   sections: [
              //     {
              //       label: t("Ajouter les semaines de rattrapage"),
              //       columns: [
              //         {
              //           name: "periode_rattrapage",
              //           label: t("Semaines de rattrapage"),
              //           type: "range-week",
              //           xs: 24,
              //           sm: 12,
              //           md: 12,
              //           visible: true,

              //         },

              //         {
              //           name: "nbre_rattrapage_periode",
              //           label: t("Nombre de jours"),
              //           type: "integer",
              //           xs: 24,
              //           sm: 12,
              //           md: 8,
              //           visible: true,
              //         },
              //       ],
              //     },
              //   ],
              //   visible: true,
              //   xs: 24,
              //   sm: 24,
              //   md: 24,
              //   buttonName: t("Ajouter une période de rattrapage"),
              //   cardTitle: t("Période de rattrapage"),
              //   cardType: "accordion",
              //   cardMd: 24,
              //   cardFieldsMd: 12,
              // },
              {
                name: "plages_vacances",
                label: t("Vacances"),
                type: "divider",
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
              },
              {
                type: "accordion",
                name: "semaines_vacances",
                label: t("Semaines de vacances"),
                canAddItems: true,

                sections: [
                  {
                    label: t("Ajouter les semaines de vacances"),
                    columns: [
                      {
                        name: "periode_vacances",
                        label: t("Semaines de vacances"),
                        type: "range-week",
                        xs: 24,
                        sm: 12,
                        md: 10,
                        visible: true,
                      },

                      {
                        name: "nbre_vacances_periode",
                        label: t("Nombre de jours"),
                        type: "integer",
                        xs: 24,
                        sm: 12,
                        md: 8,
                        visible: true,
                        min: 1,
                      },
                    ],
                  },
                ],
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
                buttonName: t("Ajouter une période de vacances"),
                cardTitle: t("Période de vacances"),
                cardType: "accordion",
                cardMd: 24,
                cardFieldsMd: 12,
              },
            ],
          },
          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "evaluation_stages",
          //       label: t("Mode d’évaluation des stagiaires"),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },
    {
      title: t("Ressources humaines"),
      visible: true,
      fields: {
        sections: [
          {
            name: "test",
            visible: true,
            inputs: [
              {
                name: "nombre_formateur_permanents",
                label: t(
                  "Nombre des formateur de l’EPF avec le statut permanent"
                ),
                type: "integer",
                visible: true,
                xs: 24,
                sm: 12,
                md: 24,
                min: 0,
                max: globalData?.data_form?.trainer_data?.filter(
                  (e) => e.trainer_data_situation === "قار"
                )?.length,
              },
              // {
              //   name: "nombre_formateur_non_permanents",
              //   label: t(
              //     "Nombre des formateur de l’EPF avec le statut non permanent"
              //   ),
              //   type: "integer",
              //   visible: true,
              //   xs: 24,
              //   sm: 12,
              //   md: 12,
              //   prefix: t("Prérempli"),
              // },
              {
                type: "table",
                name: "liste_profils_personnel",
                title: t("Profils du personnel pédagogique"),
                addTitle: t("Ajouter un profil"),
                editTitle: t("Modifier le profil"),
                addButtonLabel: t("Ajouter un profil"),
                columns: [
                  {
                    title: t("Module"),
                    dataIndex: "Module",
                    type: "select",
                    required: true,
                    options: ModulesListOptions,
                    readOnly: true,
                  },
                  {
                    title: t("Compétances"),
                    dataIndex: "compétances",
                    type: "selectTag",
                    required: true,
                  },
                  {
                    title: t("Diplômes"),
                    dataIndex: "Diplômes",
                    type: "selectTag",
                    required: true,
                  },
                ],
                visible: true,
                xs: 24,
                sm: 24,

                md: 24,
                bordered: false,
              },
            ],
          },
          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "qualification_formateurs",
          //       label: t("Qualification des formateurs"),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },
    {
      title: t("Équipements"),
      visible: true,
      fields: {
        sections: [
          {
            name: "test",
            visible: true,
            inputs: [
              {
                type: "table",
                name: "equipements",
                title: t("Équipements"),
                addTitle: t("Ajouter un équipement"),
                editTitle: t("Modifier l’équipement"),
                addButtonLabel: t("Ajouter un équipement"),
                columns: [
                  {
                    title: t("Désignation"),
                    dataIndex: "designation_equipement",
                    type: "select",
                    required: true,
                    options: equipenetsOptions,
                    width: "50%",
                  },
                  {
                    title: t("Quantité"),
                    dataIndex: "qunatite_equipement",
                    type: "number",
                    required: true,
                    width: "50%",
                    comparison: globalData?.data_form?.equipments_data,
                    comparisonKey: "equipment_label",
                    comparisonValue: "equipment_number",
                    comparisonDesignation: "designation_equipement",
                  },
                ],
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
                bordered: false,
              },
            ],
          },
          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "equipements_formation",
          //       label: t("Équipements de formation et moyens didactiques"),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },
    {
      title: t("Espaces"),
      visible: true,
      fields: {
        sections: [
          {
            name: "test",
            visible: true,
            inputs: [
              {
                type: "table",
                name: "espaces",
                title: t("Espaces"),
                addTitle: t("Ajouter un espace"),
                editTitle: t("Modifier l’espace"),
                addButtonLabel: t("Ajouter un espace"),
                columns: [
                  {
                    title: t("Désignation"),
                    dataIndex: "designation_espaces",
                    type: "select",
                    required: true,
                    options: espacesOptions,
                    width: "30%",
                  },
                  {
                    title: t("Quantité"),
                    dataIndex: "qunatite_espaces",
                    type: "number",
                    required: true,
                    width: "30%",
                    comparison: globalData?.data_form?.space_data,
                    comparisonKey: "space_data_label",
                    comparisonValue: "space_data_capacity",
                    comparisonDesignation: "designation_espaces",
                  },

                  {
                    title: t("Type de l’espace"),
                    dataIndex: "type_espaces",
                    type: "text",
                    required: true,
                    width: "30%",
                    readOnly: true,
                    // comparison: globalData?.data_form?.space_data,
                    // comparisonKey: "space_data_label",
                    // comparisonValue: "space_data_capacity",
                    // comparisonDesignation: "designation_espaces",
                  },
                ],
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
                bordered: false,
              },
            ],
          },
          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "espaces_formation",
          //       label: t("Espaces de formation"),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },
    {
      title: t("Outils pédagogiques"),
      visible: true,
      fields: {
        sections: [
          {
            name: "test",
            visible: true,
            inputs: [
              {
                type: "table",
                name: "outils_pedagogiques",
                title: t("Outils pédagogiques"),
                addTitle: t("Ajouter un outil pédagogique"),
                editTitle: t("Modifier l’outil pédagogique"),
                addButtonLabel: t("Ajouter un outil pédagogique"),
                columns: [
                  {
                    title: t("Désignation"),
                    dataIndex: "designation_outils",
                    type: "text",
                    required: true,
                    width: "50%",
                  },
                  {
                    title: t("Quantité"),
                    dataIndex: "qunatite_outils",
                    type: "number",
                    required: true,
                    width: "50%",
                  },
                ],
                visible: true,
                xs: 24,
                sm: 24,
                md: 24,
                bordered: false,
              },
            ],
          },
          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "equipements_formation",
          //       label: t("Équipements de formation et moyens didactiques"),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },

    {
      title: t("Organisation"),
      visible: true,
      fields: {
        sections: [
          {
            name: "test",
            visible: true,
            inputs: [
              {
                name: "recap_modules",
                label: t(""),
                type: "tableau",
                visible: true,
                columns: rcapModulesColumns,
                moduleItems: transformedData,
                xs: 24,
                sm: 12,
                md: 12,
                bordered: true,
              },
            ],
          },
          {
            name: "Logigramme",
            visible: true,
            inputs: [
              {
                name: "Logigramme",
                label: t(""),
                type: "tableau",
                visible: true,
                columns: recapColumns,
                moduleItems: recapData,
                xs: 24,
                sm: 12,
                md: 12,
                bordered: true,
                légende:
                  globalData?.modalites_organisation_formation !==
                  "Formation en alternance",
                legendeOptions: [
                  { "#00A4A9": "Stage d'intégration" },
                  { "#024fa8": "Stage d'observation" },
                ],
              },
            ],
          },

          {
            name: "datesHomologation",
            visible:
              params?.state?.selectedType === "existante" ||
              globalData?.selectedType === "existante",
            // visible:true,
            inputs: [
              {
                name: "dateDebutHomologation",
                label: t("Date de début d'homologation"),
                type: "date",
                visible:
                  params?.state?.selectedType === "existante" ||
                  globalData?.selectedType === "existante",
                disabledDate: disableFutureDates,
                xs: 24,
                sm: 12,
                md: 12,
              },
              {
                name: "dateFinHomologation",
                label: t("Date de fin d'homologation"),
                type: "date",
                visible:
                  params?.state?.selectedType === "existante" ||
                  globalData?.selectedType === "existante",
                xs: 24,
                sm: 12,
                md: 12,
                disabledDate: disableDateFin(
                  form?.getFieldValue("dateDebutHomologation")
                ),
              },
            ],
          },

          // {
          //   name: t("Avis rapporteur"),
          //   visible: role === "rapporteur",
          //   inputs: [
          //     {
          //       name: "mise_en_oeuvre_formation",
          //       label: t("La mise en œuvre de la formation"),
          //       type: "area",
          //       visible: true,
          //       xs: 24,
          //       sm: 24,
          //       md: 24,
          //       avisRapporteur: true,
          //     },
          //     {
          //       name: "favorable_homologation",
          //       label: t("Favorable pour l’homologation au niveau demandé"),
          //       type: "radio",
          //       visible: true,
          //       options: [t("Oui"), t("Non")],
          //       xs: 24,
          //       sm: 12,
          //       md: 12,
          //       avisRapporteur: true,
          //     },
          //     {
          //       name: "correspondance_niveau",
          //       label: t(
          //         "Correspondance du niveau demandé avec l’emploi ciblé"
          //       ),
          //       type: "radio",
          //       visible: true,
          //       options: [t("Oui"), t("Non")],

          //       xs: 24,
          //       sm: 12,
          //       md: 12,
          //       avisRapporteur: true,
          //     },
          //   ],
          // },
        ],
      },
    },
  ];

  const visibleSteps = steps.filter((step) => step.visible);
  const saveSession = () => {
    let value = {
      ...globalData,
      ...form.getFieldsValue(),
      ...params?.state?.epf_data,
    };
    if (currentStep === 3) {
      const formValues = form.getFieldsValue();

      const typePeriode = form.getFieldValue("type_periode");

      const semainesParPeriode = [];
      let i = 1;
      while (true) {
        const v = parseInt(form.getFieldValue(`nbre_semaines_periode_${i}`));
        if (isNaN(v)) break;
        semainesParPeriode.push(v);
        i++;
      }

      const modules_planning = [];

      let currentWeekIndex = 1;

      for (let pIndex = 0; pIndex < semainesParPeriode.length; pIndex++) {
        const periodeLabel =
          typePeriode === "Semestrielle"
            ? `Semestre ${pIndex + 1}`
            : `Trimestre ${pIndex + 1}`;

        const periodeData = {};

        for (const mod of modules[0]?.items) {
          const values = [];

          for (
            let j = currentWeekIndex;
            j < currentWeekIndex + semainesParPeriode[pIndex];
            j++
          ) {
            const key = mod.code_module;
            const intitule =
              modules[0]?.items.find((e) => e.code_module === key)
                ?.intitulé[0] + j;
            const val = formValues[intitule];
            values.push(typeof val === "number" ? val : 0);
          }

          periodeData[mod.code_module] = values;
        }

        modules_planning.push({
          [periodeLabel]: periodeData,
        });

        currentWeekIndex += semainesParPeriode[pIndex];
      }
      value = {
        ...value,
        modules_planning,
        restantModules,
      };
    }
    sessionStorage.setItem("globalData", JSON.stringify(value));
    setGlobalData(value);
  };
  const isAllModulesValid = () => {
    const totalWeeks = globalData?.duree_effective;

    const modulesAreValid = modules[0]?.items.every((mod) => {
      return restantModules[mod.intitulé] === 0;
    });

    if (!modulesAreValid) {
      notification.error({
        message: t("Erreur"),
        description: t("Tous les modules doivent être entièrement planifiés."),
        duration: 0,
      });
      return false;
    }

    for (let i = 1; i <= totalWeeks; i++) {
      let weeklyTotal = 0;
      modules[0]?.items.forEach((mod) => {
        const val = form.getFieldValue(mod.intitulé + i);
        weeklyTotal += typeof val === "number" ? val : 0;
      });
      // if (weeklyTotal === 0) {
      //   notification.error({
      //     message: t("Erreur"),
      //     description: t("CHarge hebdo 0"),
      //     duration: 0,
      //   });

      //   return false;
      // }
      if (weeklyTotal > params?.state?.epf_data?.charge_hebdo) {
        triggerNextStep.current = true;
        setShowConfirm(true);
        return;

        // notification.error({
        //   message: t("Erreur"),
        //   description: t("CHarge hebdo sup à 34"),
        //   duration: 0,
        // });

        // return false;
      }
    }

    return true;
  };

  const checkModulesCoverage = () => {
    const profils = form.getFieldValue("liste_profils_personnel") || [];
    const coveredModules = profils.map((p) => p.Module);

    const allModules = modules?.[0]?.items?.map((m) => m.intitulé[0]) || [];

    const missingModules = allModules.filter(
      (mod) => !coveredModules.includes(mod)
    );

    return missingModules;
  };

  function mapDataJsonFromSteps() {
    const stepsMapped = steps
      .filter((_, index) => ![1, 3, 4].includes(index))
      .map((step) => ({
        title: step.title,
        type: "form",
        sections: step.fields.sections
          .filter((s) => s.name !== "Avis rapporteur" && s.visible)
          .map((section) => ({
            name: section.name,
            fields: section.inputs
              .filter(
                (field) =>
                  field.visible &&
                  field.type !== "info" &&
                  field.type !== "global"
              )
              .map((field) => {
                if (field.type === "tableau") {
                  return {
                    label: field.label,
                    type: "table",
                    columns: field.columns?.map((col) => ({
                      title:
                        typeof col.title === "string"
                          ? col.title
                          : col?.dataIndex === "stageObservation"
                          ? "Stage d'observation"
                          : col?.dataIndex === "stageIntegration"
                          ? "Stage d'intégration"
                          : col.title.props.title[0],
                      dataIndex: col.dataIndex,
                    })),
                    rows: field.moduleItems || [],
                  };
                }

                if (field.type === "table") {
                  const rows = globalData?.[field.name] || [];
                  return {
                    label: field.title,
                    type: "table",
                    columns: field.columns?.map((col) => ({
                      title: col.title,
                      dataIndex: col.dataIndex,
                    })),
                    rows: rows,
                  };
                }

                if (field.type === "accordion") {
                  return {
                    name: field.label,
                    fields:
                      field.inputs?.map((subField) => ({
                        label: subField.label,
                        type:
                          subField.type === "radio" ||
                          subField.type === "checkbox" ||
                          subField.type === "file" ||
                          subField.type === "divider"
                            ? subField.type
                            : subField.type === "tableau"
                            ? "table"
                            : "text",
                        value:
                          form?.getFieldValue?.(subField.name) ??
                          globalData?.[subField.name] ??
                          "",
                      })) || [],
                  };
                }

                const value =
                  form?.getFieldValue?.(field.name) ??
                  globalData?.[field.name] ??
                  "";

                const jsonToReturn = {
                  label: field.label,
                  type: [
                    "radio",
                    "tableau",
                    "table",
                    "selectTag",
                    "checkbox",
                    "file",
                    "divider",
                  ].includes(field.type)
                    ? field.type
                    : "text",
                  value,
                  ...(["radio", "checkbox"].includes(field.type) && {
                    options: field.options || [],
                  }),
                };

                return jsonToReturn;
              }),
          })),
      }));

    const periodsStep = {
      title: "Périodes",
      type: "form",
      sections: [
        {
          name: "Semaines d'examen",
          fields: [
            {
              label: "Semaines d'examen",
              type: "table",
              columns: [
                { title: "Début", dataIndex: "start" },
                { title: "Fin", dataIndex: "end" },
                { title: "Examen", dataIndex: "examen_oui" },
                { title: "Rattrapage", dataIndex: "ratrapage_oui" },
              ],
              bordered: true,
              rows:
                globalData?.semaines_examen?.[0]?.items?.map((item) => ({
                  start: item.periode_examen?.start + 1,
                  end: item.periode_examen?.end + 1,
                  examen_oui: item.examen_oui,
                  ratrapage_oui: item.ratrapage_oui,
                })) || [],
            },
          ],
        },
        {
          name: "Périodes de rattrapage",
          fields: [
            {
              label: "Périodes de rattrapage",
              type: "table",
              columns: [
                { title: "Début", dataIndex: "start" },
                { title: "Fin", dataIndex: "end" },
              ],
              bordered: true,
              rows:
                globalData?.semaines_examen?.[0]?.items
                  ?.filter((item) => item.periode_rattrapage)
                  ?.map((item) => ({
                    start: item.periode_rattrapage?.start + 1,
                    end: item.periode_rattrapage?.end + 1,
                  })) || [],
            },
          ],
        },
        {
          name: "Semaines de vacances",
          fields: [
            {
              label: "Semaines de vacances",
              type: "table",
              columns: [
                { title: "Début", dataIndex: "start" },
                { title: "Fin", dataIndex: "end" },
              ],
              bordered: true,
              rows:
                globalData?.semaines_vacances?.[0]?.items?.map((item) => ({
                  start: item.periode_vacances?.start + 1,
                  end: item.periode_vacances?.end + 1,
                })) || [],
            },
          ],
        },
      ],
    };

    // On stocke la dernière étape AVANT ajout de periodsStep
    const lastOriginalStep =
      stepsMapped.length > 0 ? stepsMapped[stepsMapped.length - 1] : null;

    const recapIndex = stepsMapped.findIndex(
      (step) => step.title?.toLowerCase() === "recap"
    );

    if (recapIndex !== -1) {
      stepsMapped.splice(recapIndex, 0, periodsStep);
    } else {
      stepsMapped.push(periodsStep);
    }

    // On déplace la dernière étape originale à la 2ème position
    if (lastOriginalStep) {
      const index = stepsMapped.findIndex(
        (step) => step.title === lastOriginalStep.title
      );
      if (index !== -1) {
        stepsMapped.splice(index, 1); // remove
        stepsMapped.splice(1, 0, lastOriginalStep); // insert at index 1
      }
    }

    return stepsMapped;
  }

  const nextStep = async () => {
    if (currentStep < steps.length - 1) {
      if (currentStep === 0) {
        const values = form.getFieldsValue();
        const dureeEffective = parseInt(values.duree_effective);
        const nbrePeriode = parseInt(values.nbre_periode, 10);
        const duree_effective_totale = parseInt(values.duree_effective_totale);
        const duree_vacances = parseInt(values.duree_vacances);
        const duree_evaluation = parseInt(values.duree_evaluation);
        const duree_rattrapage = parseInt(values.duree_rattrapage);

        const durees_totales =
          duree_vacances + duree_evaluation + duree_rattrapage + dureeEffective;

        let totalPériodes = 0;
        for (let i = 1; i <= nbrePeriode; i++) {
          totalPériodes += parseInt(
            values[`nbre_semaines_periode_${i}`] || 0,
            10
          );
        }

        if (totalPériodes !== dureeEffective) {
          notification.error({
            message: "Durée insuffisante",
            description: `La somme des périodes doit être égale durée effective (${dureeEffective} semaines).`,
            duration: 0,
          });
          return;
        } else if (durees_totales !== duree_effective_totale) {
          notification.error({
            message: "Durée insuffisante",
            description: `La somme des vacances, évaluation, ratrappage et la durée effective doit être égale à la durée effective (${duree_effective_totale} semaines).`,
            duration: 0,
          });
          return;
        } else {
          setCurrentStep(currentStep + 1);
          saveSession();
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      } else if (currentStep === 1) {
        const totalWeeks = globalData.duree_effective;

        if (modules[0]?.items?.length > 0 && totalWeeks > 0) {
          const initData = Array.from({ length: totalWeeks }, (_, i) => ({
            week: i + 1,
            weeklyTotal: 0,
            ...modules[0]?.items?.reduce(
              (acc, mod) => ({ ...acc, [mod.intitulé]: 0 }),
              {}
            ),
          }));

          setData(initData);

          modules[0]?.items.forEach((item, index) => {
            const prefix = item.type === "Général" ? "MG" : "MS";
            item.code_module = `${prefix} ${index + 1}`;
            item.seuil_réussite = item.seuil_réussite
              ? item.seuil_réussite
              : "sur 20";
          });
          setGlobalData({
            ...globalData,
            modules_formation: modules,
          });
        }
        const items = modules[0].items;
        const groupedByIntitule = items.reduce((acc, item) => {
          const key = item.intitulé[0];
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(item);
          return acc;
        }, {});

        for (const [intitule, group] of Object.entries(groupedByIntitule)) {
          if (group.length > 1) {
            notification.error({
              message: t("Erreur"),
              description: t(`Module ${intitule} en doublon`),
              duration: 0,
            });
            return;
          }
        }

        const heuresObservation =
          parseInt(form.getFieldValue("duree_stage_heures_observation")) *
          parseInt(form.getFieldsValue().duree_stage_mois_observation) *
          4;
        const heuresIntegration =
          parseInt(form.getFieldValue("duree_stage_heures_integration")) *
          parseInt(form.getFieldsValue().duree_stage_mois_integration) *
          4;
        if (heuresIntegration < 160) {
          notification.error({
            message: "Stage d'intégration insuffisant",
            description: `La durée du stage d'intégration est ${heuresIntegration} heures. Elle doit être au minimum de 160 heures.`,
            duration: 0,
          });
        } else if (heuresObservation < 160) {
          notification.error({
            message: "Stage d'observation insuffisant",
            description: `La durée du stage d'observation est ${heuresObservation} heures. Elle doit être au minimum de 160 heures.`,
            duration: 0,
          });
        } else {
          setCurrentStep(currentStep + 1);
          saveSession();
          notification.destroy();
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      } else if (currentStep === 4) {
        // setCurrentStep(currentStep + 1);
        saveSession();
        if (role !== "rapporteur") {
          const sommes = {
            examen: 0,
            rattrapage: 0,
            vacances: 0,
          };

          const periodeKeys = [
            {
              key: "semaines_examen",
              field: "nbre_examen_periode",
              target: "examen",
            },
            {
              key: "semaines_vacances",
              field: "nbre_vacances_periode",
              target: "vacances",
            },
            {
              key: "semaines_examen",
              field: "nbre_rattrapage_periode",
              target: "rattrapage",
            },
          ];

          periodeKeys.forEach(({ key, field, target }) => {
            const semaines = form.getFieldValue(key);
            semaines?.[0]?.items?.forEach((item) => {
              sommes[target] += item?.[field] || 0;
            });
          });
          const validations = [
            {
              type: "examen",
              value: sommes.examen,
              limit: globalData?.duree_evaluation * 7,
              label: "la durée d'évaluation",
            },
            {
              type: "rattrapage",
              value: sommes.rattrapage,
              limit: globalData?.duree_rattrapage * 7,
              label: "la durée du rattrapage",
            },
            {
              type: "vacances",
              value: sommes.vacances,
              limit: globalData?.duree_vacances * 7,
              label: "la durée des vacances",
            },
          ];

          const error = validations.find(({ value, limit }) => value > limit);

          if (error) {
            notification.error({
              message: "Erreur",
              description: `La somme des jours ${
                error.type === "examen" ? "d'" : "de"
              } ${error.type} (${
                error.value
              }) doit être inférieure ou égale à ${error.label} (${
                error.limit
              }).`,
              duration: 0,
            });
          } else {
            if (
              sessionStorage.getItem("consulter") !== "true" &&
              role !== "rapporteur"
            ) {
              setOpenModal(
                insertSpecialLines(data, plagesMultiple, orderedConflicts)
              );
            } else {
              setCurrentStep(currentStep + 1);
              saveSession();
              notification.destroy();
            }
          }

          return;
        }
      } else if (currentStep === 3 && !isAllModulesValid()) {
        return;
      } else if (currentStep === 5) {
        const missing = checkModulesCoverage();
        if (missing.length > 0) {
          notification.error({
            message: t("Erreur"),
            description: `Les modules suivants ne sont pas assignés à un profil : ${missing.join(
              ", "
            )}`,
            duration: 0,
          });
          return;
        }
        setCurrentStep(currentStep + 1);
        saveSession();
        notification.destroy();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        setCurrentStep(currentStep + 1);
        saveSession();
        notification.destroy();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    } else {
      setIsLoading(true);
      notification.destroy();

      const dataJson = mapDataJsonFromSteps();
      const payload = {
        current_step: 0,
        additional_form: "{}",
        json_prod: {
          ...globalData,
          ...form.getFieldsValue(),
          ...params.state.epf_data,
          dataJson: dataJson,
        },
      };
      let data;
      if (
        params.state.selectedType === "existante" ||
        globalData.selectedType === "existante"
      ) {
        data = await saveAffaire(
          payload,
          params.state.etat === "dossierManquantDR"
            ? "soumissionDossierManquantAvisDRHomologationEx"
            : "soumissionHomologationExistante",
          setIsLoading,
          "homologationExistante"
        );
      } else {
        data = await saveAffaire(
          payload,
          params.state.etat === "dossierManquant"
            ? "soumissionDossierManquantAvisRapporteur"
            : params.state.etat === "dossierManquantDR"
            ? "soumissionDossierManquantAvisDR"
            : "soumissionHomologation",
          setIsLoading,
          "homologation"
        );
      }
      if (data) {
        sessionStorage.removeItem("id_homologation");
        navigate("/demandes");
        setIsLoading(false);
      }
    }
  };
  const prevStep = () => setCurrentStep((prev) => prev - 1);
  const handleClickOutside = async (event) => {
    if (
      ref.current &&
      !ref?.current?.contains(event?.target) &&
      !params?.state?.id_homologation &&
      !params?.state?.etat
    ) {
      const payload = {
        current_step: currentStep,
        json_prod: {
          ...globalData,
          ...form.getFieldsValue(),
          ...params.state.epf_data,
          restantModules: JSON.parse(sessionStorage.getItem("globalData"))
            ?.restantModules,
          selectedType: params?.state?.selectedType,
        },
      };
      sessionStorage.setItem("payload", JSON.stringify(payload));
    }
    sessionStorage.removeItem("current_step");
  };
  const demandeHomologation = async () => {
    setIsLoading(true);
    const payload = {
      ligne_produit:
        params.state.selectedType === "existante" ||
        globalData?.selectedType === "existante"
          ? import.meta.env
              .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_HOMOLOGATION_EXISTANTE
          : params.state.selectedType === "renouvellement"
          ? import.meta.env
              .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_RENOUVELLEMENT_HOMOLOGATION
          : import.meta.env.VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_HOMOLOGATION,
      id_opp: null,
      nom_produit: "THAMM PRODUCT (  )",
      id_produit: "d728587fff2d87201eae0a158507d814",
      cmp: "987654300",
      user_id: user.id_user,
      date_effet: "2024-01-02",
      souscription: "2024-01-02",
      id_fractionnement: 11,
      affected: "1002237",
      id_formation: params.state.id_formation,
      registration_number: params.state.epf_data?.registration_number,
      data_form_prod: JSON.stringify({
        ...globalData,
        ...form.getFieldsValue(),
        ...params.state.epf_data,
        selectedType: params?.state?.selectedType,
      }),
    };
    const data = await addAffaire(payload, "soumission", null);
    if (data) {
      if (
        params.state.selectedType === "renouvellement" ||
        globalData?.selectedType === "renouvellement"
      ) {
        await updateAffaireAnnexe({
          id_affaire1: params?.state?.id_affaire_parent,
          id_affaire2: data?.id_affaire,
          type: 2,
        });
      }
      setIsLoading(false);
      sessionStorage.setItem("id_homologation", data?.id_affaire);
    }
  };

  const saveData = () => {
    const epfData = params.state.epf_data;
    form.setFieldsValue(
      JSON.parse(sessionStorage.getItem("globalData"))
        ? {
            ...JSON.parse(sessionStorage.getItem("globalData")),
            type_stage_observation: "Stage d'observation",
            type_stage_integration: "Stage d'intégration",
            dateDebutHomologation: dayjs(globalData.dateDebutHomologation),
            dateFinHomologation: dayjs(globalData.dateFinHomologation),
          }
        : {
            ...form.getFieldsValue(),
            numEnregistrement: epfData?.registration_number,
            denomination_epf: epfData?.nom_etablissement?.split(",")[1]?.trim()
              ? epfData?.nom_etablissement?.split(",")[1]?.trim()
              : epfData?.nom_etablissement,
            adresse_epf: epfData?.establishment_data_address,
            telephone_epf: epfData?.establishment_data_phone_number_1,
            fax_epf: epfData?.establishment_data_fax_number,
            email_epf: epfData?.establishment_data_email,
            specialite:
              epfData?.training_nature_data?.training_type_data_specialty?.split(
                " - "
              )[0],
            diplome:
              epfData?.training_nature_data?.training_type_data_diploma?.split(
                " - "
              )[1],
            niveau: epfData?.details_specialite?.min_niveau_requis,
            Secteur: epfData?.training_nature_data?.training_type_data_sector,
            sousSecteur:
              epfData?.training_nature_data?.training_type_data_sub_sector,
            chargé_epf:
              epfData?.establishment_director_data_last_name +
              " " +
              epfData?.establishment_director_data_first_name,
            organisation_formation: "Cours du jour",
            type_stage_observation: "Stage d'observation",
            type_stage_integration: "Stage d'intégration",
          }
    );
    setGlobalData(JSON.parse(sessionStorage.getItem("globalData")));
    if (
      (!params.state.brouillon &&
        !params.state.id_homologation &&
        !params?.state?.etat) ||
      params?.state?.selectedType === "renouvellement"
    ) {
      demandeHomologation();
    }

    const savedOrderedConflicts = sessionStorage.getItem("orderedConflicts");
    if (savedOrderedConflicts) {
      setOrderedConflicts(JSON.parse(savedOrderedConflicts));
    }
  };

  const handleSetRestants = () => {
    if (!Array.isArray(modules)) return;

    const newMapping = {};
    const existingRestants = globalData?.restantModules || {};

    modules?.[0]?.items.forEach((module) => {
      const nameOfModule = module?.intitulé;
      const heuresProposées = module?.nbre_heures_proposé || 0;

      newMapping[nameOfModule] =
        existingRestants[nameOfModule] ?? heuresProposées;
    });

    setRestantModules(newMapping);
  };

  useEffect(() => {
    saveData();

    if (!params?.state?.id_affaire) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    handleSetRestants();
  }, [modules]);

  return (
    <>
      <Card
        ref={ref}
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Nouvelle Homologation</span>
            <Button type="primary" onClick={() => navigate("/formations")}>
              <BookOpen strokeWidth={1.25} />
              {t("Liste des formations")}
            </Button>
          </div>
        }
        bordered={false}
        style={{
          margin: "auto",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <ModalValidPlanning
          openModal={openModal}
          setOpenModal={setOpenModal}
          modules={modules}
          data={data}
          setCurrentStep={setCurrentStep}
          currentStep={currentStep}
          plagesMultiple={plagesMultiple}
        />

        <ConflictOrderModal
          visible={showConflictModal}
          onCancel={() => setShowConflictModal(false)}
          onOk={(conflictKey, items) => {
            const orderedList = items.map((item) => {
              let type = "";
              let typeStage = "";
              if (item.colName?.includes("integration")) {
                type = "stage";
                typeStage = "intégration";
              } else if (item.colName?.includes("obseravation")) {
                type = "stage";
                typeStage = "observation";
              } else if (item.colName?.includes("examen")) {
                type = "examen";
              } else if (item.colName?.includes("rattrapage")) {
                type = "rattrapage";
              } else if (item.colName?.includes("vacances")) {
                type = "vacances";
              } else {
                type = "autre";
              }

              return {
                type,
                data: { ...item, typeStage: typeStage },
              };
            });
            setOrderedConflicts((prev) => ({
              ...prev,
              [conflictKey]: orderedList,
            }));

            setShowConflictModal(false);
          }}
          conflicts={conflictingPlages[currentConflictKey] || []}
          conflictKey={currentConflictKey}
        />

        <Steps
          current={currentStep}
          style={{ marginBottom: "20px", width: "100%" }}
          onChange={(next) => {
            if (next > currentStep) {
              form
                .validateFields()
                .then(() => {
                  nextStep();
                })
                .catch(() => {
                  notification.error({
                    message: t("Erreur"),
                    description: t(
                      "Veuillez remplir tous les champs obligatoires."
                    ),
                    duration: 0,
                  });
                });
            } else {
              setCurrentStep(next);
            }
          }}
        >
          {visibleSteps.map((step) =>
            step.visible ? (
              <Step
                key={step.title}
                title={steps[currentStep] === step ? step.title : null}
              />
            ) : null
          )}
        </Steps>

        <Form
          form={form}
          layout="vertical"
          onFinish={nextStep}
          onFinishFailed={() => {
            notification.error({
              message: t("Erreur"),
              description: t("Veuillez vérifier tous les champs."),
              duration: 0,
            });
          }}
          disabled={
            params?.state?.id_homologation ||
            params?.state?.etat === "rappoprtAccepté"
          }
          onValuesChange={(changedValues, allValues) => {
            if (
              allValues.capacite_acceuil_annuelle &&
              allValues.nombre_apprenants_groupe
            ) {
              const nbreGrp =
                allValues.capacite_acceuil_annuelle /
                allValues.nombre_apprenants_groupe;
              form.setFieldsValue({
                ...form.getFieldsValue(),
                nombre_groupes: Math.round(nbreGrp),
              });
            }

            if (
              allValues.duree_vacances &&
              allValues.duree_evaluation &&
              allValues.duree_rattrapage &&
              allValues.duree_effective
            ) {
              const dureeTotale =
                allValues.duree_vacances +
                allValues.duree_evaluation +
                allValues.duree_rattrapage +
                allValues.duree_effective;
              form.setFieldsValue({
                ...form.getFieldsValue(),
                duree_effective_totale: Math.round(dureeTotale),
              });
            }

            const modules = allValues.modules_formation?.[0]?.items;
            const changedPath = Object.keys(changedValues)[0];

            if (
              changedPath?.startsWith("modules_formation") &&
              modules &&
              Array.isArray(modules)
            ) {
              modules.forEach((item, index) => {
                const proposé = item?.nbre_heures_proposé;
                const théorique = item?.nbre_heures_théorique;

                if (proposé != null && théorique != null) {
                  const pratique = Math.round(proposé - théorique);
                  const fieldPath = [
                    "modules_formation",
                    0,
                    "items",
                    index,
                    "nbre_heures_pratique",
                  ];

                  form.setFieldValue(fieldPath, pratique);

                  if (pratique < 1) {
                    form.setFields([
                      {
                        name: fieldPath,
                        errors: ["La valeur doit être supérieure ou égale à 1"],
                      },
                    ]);
                  } else {
                    form.setFields([
                      {
                        name: fieldPath,
                        errors: [],
                      },
                    ]);
                  }
                }
              });
            }
          }}
        >
          <StepForm
            fields={visibleSteps[currentStep]?.fields}
            id_homologation={params?.state?.id_homologation}
          />

          <div style={{ textAlign: "end", marginTop: "20px" }}>
            {currentStep > 0 && (
              <Button
                onClick={prevStep}
                style={{ marginInline: "1rem" }}
                disabled={false}
              >
                {t("Précédant")}
              </Button>
            )}
            {currentStep < steps.length - 1 ? (
              <Popconfirm
                open={showConfirm && !params?.state?.id_homologation}
                title={t(
                  `La charge dépasse ${params?.state?.epf_data?.charge_hebdo}h pour une ou plusieurs semaines. Continuer ?`
                )}
                onConfirm={() => {
                  setShowConfirm(false);
                  triggerNextStep.current = false;
                  setCurrentStep(currentStep + 1);
                  saveSession();
                  notification.destroy();
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                  // nextStep()
                }}
                onCancel={() => {
                  setShowConfirm(false);
                  triggerNextStep.current = false;
                }}
                okText={t("Oui")}
                cancelText={t("Non")}
              >
                <Button type="primary" htmlType="submit" disabled={false}>
                  {t("Suivant")}
                </Button>
              </Popconfirm>
            ) : role !== "rapporteur" ? (
              <Button type="primary" htmlType="submit">
                {t("Soumettre")}
              </Button>
            ) : null}
          </div>
        </Form>
        {sessionStorage.getItem("consulter") !== "true" &&
          (params?.state?.etat === "dossierManquant" ||
            params?.state?.etat === "rappoprtAccepté") && (
            <RapportInputs idHomologation={params?.state?.id_homologation} />
          )}
      </Card>
      <DeleteBrouillonModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        typeAffaire="homologation"
      />
      {sessionStorage.getItem("consulter") !== "true" &&
        !params?.state?.etat && (
          <Space>
            <Button
              className={classes.buttonCancel}
              onClick={() => setConfirmModal(true)}
            >
              <Trash2 strokeWidth={1.25} />
              {t("Annuler la demande")}
            </Button>
            <Button
              className={classes.buttonCreate}
              onClick={async () => {
                const payload = {
                  current_step: currentStep,
                  json_prod: {
                    ...globalData,
                    ...form.getFieldsValue(),
                    selectedType: params?.state?.selectedType,
                  },
                };

                await saveAffaire(
                  payload,
                  "Brouillon",
                  setIsLoading,
                  "homologation"
                );
                sessionStorage.removeItem("current_step");
                setNbrBrouillon((prevDataSource) => {
                  if (prevDataSource >= 1) {
                    return prevDataSource + 1;
                  }
                });
                navigate("/brouillon");
              }}
            >
              <Save strokeWidth={1.25} />
              {t("Sauvegarder au brouillon")}
            </Button>
          </Space>
        )}
    </>
  );
};

export default NouvelleHomologation;
